import { useTranslation } from 'react-i18next';
import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    FluidImage,
    Link,
} from '@vp/swan';
import { sanitiseLocale } from '../../../../i18n/config';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { proLogoDesignUrl } from '../../../../utils/urls';

export const PromotionsBanner = () => {
    const { t, i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);

    const ctaRef = useTrackNavigationClicked(
        'Design Services',
        'Feature Banner Promotions CTA',
        t('Logomaker GenAi Landing Page > Promotions Banner > CTA.contentfulUrl'),
        'logoMaker',
    );

    return (
        <Banner
            textBoxHorizontalAlign="right"
            backgroundColor="warm-white"
            as="section"
            id="design-services"
            marginY="between-sections"
            paddingX={{ xs: 5, sm: 6, md: 8, lg: 8, xl: 10 }}
        >
            <BannerImageContainer>
                <BannerImage>
                    <FluidImage
                        src={t('Logomaker GenAi Landing Page > Promotions Banner > Image.src')}
                        alt={t(
                            'Logomaker GenAi Landing Page > Promotions Banner > Image > Alt Text.value',
                        )}
                    />
                </BannerImage>
            </BannerImageContainer>
            <BannerTextContainer>
                <BannerText textAlign="left">
                    <BannerEyebrow>
                        {t('Logomaker GenAi Landing Page > Promotions Banner > Eyebrow.value')}
                    </BannerEyebrow>
                    <BannerTitle as="h2">
                        {t('Logomaker GenAi Landing Page > Promotions Banner > Title.value')}
                    </BannerTitle>
                    <BannerDescription as="p">
                        {t('Logomaker GenAi Landing Page > Promotions Banner > Description.value')}
                    </BannerDescription>
                    <BannerLinks style={{ justifyContent: 'left' }}>
                        <Link href={proLogoDesignUrl(locale)} skin="cta" ref={ctaRef}>
                            {t('Logomaker GenAi Landing Page > Promotions Banner > CTA.text')}
                        </Link>
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
        </Banner>
    );
};
